<template>
  <div>
    <list
      :items="semesters"
      :pagination="semestersPagination"
      :title="{ label: 'ترم ها', value: 'semester' }"
      :loading="semestersLoading"
      @changedPagination="changedPagination"
      @changedSearch="changedSearch"
    />
    <hr class="my-2" />
    <list
      :items="courses"
      :pagination="coursesPagination"
      :title="{ label: 'دوره ها', value: 'course' }"
      :loading="coursesLoading"
      @changedPagination="changedPagination"
      @changedSearch="changedSearch"
    />
    <!-- <hr class="my-2" />
    <list
      :items="eventsPagination"
      :pagination="eventsPagination"
      :title="{ label: 'رویداد ها', value: 'event' }"
      :loading="eventsLoading"
    /> -->
  </div>
</template>

<script>
import List from "./List.vue";
export default {
  components: {
    List,
  },
  data() {
    return {
      semestersPagination: {},
      semesters: [],
      coursesPagination: {},
      courses: [],
      eventsPagination: {},
      events: [],
      eventsLoading: false,
      coursesLoading: false,
      semestersLoading: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  methods: {
    async changedPagination(req) {
      let baseUrl = Object.keys(this.userData).length ? "/panel/" : "/front/";
      if (req.api == "semester") {
        await this.getSemesters(baseUrl, req.page);
      } else if (req.api == "course") {
        await this.getCourses(baseUrl, req.page);
      }
    },
    async changedSearch(req) {
      let baseUrl = Object.keys(this.userData).length ? "/panel/" : "/front/";
      if (req.api == "semester") {
        await this.getSemesters(baseUrl, null, req.key);
      } else if (req.api == "course") {
        await this.getCourses(baseUrl, null, req.key);
      }
    },
    async getSemesters(baseUrl, page, key) {
      this.semestersLoading = true;

      try {
        const { data } = await this.$http.get(
          `${baseUrl}semesters?includes=teachers&per_page=8&page=${page || 1}` +
            (key ? `&key=${key}` : "")
        );
        this.semesters = data.data.semesters;
        this.semestersPagination = data.data.meta.pagination;
      } catch (err) {}
      this.semestersLoading = false;
    },
    async getCourses(baseUrl, page, key) {
      this.coursesLoading = true;

      try {
        const { data } = await this.$http.get(
          `${baseUrl}courses?includes=teachers&per_page=8&page=${page || 1}` +
            (key ? `&key=${key}` : "")
        );
        this.courses = data.data.courses;
        this.coursesPagination = data.data.meta.pagination;
      } catch (err) {}
      this.coursesLoading = false;
    },
    async getEvents(baseUrl, page, key) {
      try {
        const { data } = await this.$http.get(
          `${baseUrl}events?includes=teachers&per_page=8&page=${page || 1}` +
            (key ? `&key=${key}` : "")
        );
        this.events = data.data.events;
        this.eventsPagination = data.data.meta.pagination;
      } catch (err) {}
    },
  },
  async created() {
    let baseUrl = Object.keys(this.userData).length ? "/panel/" : "/front/";
     this.getSemesters(baseUrl);
     this.getCourses(baseUrl);
  },
};
</script>
